import { TProject, TView } from "@/types";

/**
 * Whether the view already gathers the project without being told:
 * everything (nothing picked), the project itself, or its client (a
 * client brings its projects, present and future).
 */
export const viewIncludesProject = (
	view: Pick<TView, "isEverything" | "projects" | "clients">,
	project: Pick<TProject, "id" | "client">
): boolean =>
	view.isEverything ||
	view.projects.some((p) => p.id === project.id) ||
	(!!project.client && view.clients.some((c) => c.id === project.client!.id));
